// extracted by mini-css-extract-plugin
export default {"invoice":"Invoice_invoice__nRSoH"};